import { EMPTY_GUID } from "@/utils/constant";
import { readCookie } from "@/utils/helper";

/** Reads visit tracking id from cookies (supports legacy cookie names). */
export function getVisitGuidForTracking(): string {
  return (
    readCookie("visitGuid") ||
    readCookie("visitid") ||
    readCookie("visitId") ||
    EMPTY_GUID
  );
}

/** Reads visitor tracking id from cookies (supports legacy cookie names). */
export function getVisitorGuidForTracking(): string {
  return (
    readCookie("visitorGuid") ||
    readCookie("visitorId") ||
    readCookie("visitorid") ||
    EMPTY_GUID
  );
}

/** Reads user guid for tracking; guests fall back to EMPTY_GUID (WriteSimpli pattern). */
export function getUserGuidForTracking(): string {
  return readCookie("userguid") || EMPTY_GUID;
}

export function hasVisitTrackingCookie(): boolean {
  return getVisitGuidForTracking() !== EMPTY_GUID;
}
